import { useDisable } from "hooks/use-disable";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IHeaderTable } from "types/global";

// 86d37db3t — one header layout for every status. The 4 cost columns
// (shipping_cost / secondary_driver_cost / drop_cost / max_shipping_cost)
// are hidden per Hidden-not-deleted: values remain in the DB on historical
// rows but the column no longer renders.
export const useWorkListHeader = () => {
  const { t } = useTranslation();
  const [headers, setHeader] = useState<IHeaderTable[]>([]);
  const [disabled] = useDisable();

  useEffect(() => {
    const defaultHeaders: IHeaderTable[] = [
      {
        thaiLabel: t("logistic.work_list.location_unique_id"),
        width: 154,
        align: "left",
        required: true,
      },
      {
        thaiLabel: t("logistic.work_list.location_name"),
        width: 134,
        align: "left",
        required: true,
      },
      {
        thaiLabel: t("logistic.work_list.type"),
        width: 84,
        align: "left",
        required: true,
      },
      {
        thaiLabel: t("logistic.work_list.reference_code"),
        width: 154,
        align: "left",
      },
      {
        thaiLabel: t("logistic.work_list.distance"),
        width: 104,
        align: "right",
      },
      {
        thaiLabel: t("logistic.work_list.coordinator_name"),
        width: 134,
        align: "left",
      },
      {
        thaiLabel: t("logistic.work_list.coordinator_phone"),
        width: 144,
        align: "left",
      },
      {
        thaiLabel: t("logistic.work_list.special_request"),
        width: 134,
        align: "left",
      },
      {
        thaiLabel: t("logistic.work_list.customer_name"),
        width: 134,
        align: "left",
      },
      {
        thaiLabel: t("logistic.work_list.seal_no"),
        width: 154,
        align: "left",
      },
      {
        thaiLabel: t("logistic.work_list.end_date"),
        width: 184,
        align: "left",
      },
      {
        thaiLabel: t("logistic.work_list.arrived_kilometer"),
        width: 134,
        align: "left",
      },
    ];

    if (!disabled) {
      setHeader([
        ...defaultHeaders,
        {
          label: "",
          thaiLabel: "",
          width: 35,
        },
      ]);
    } else {
      setHeader(defaultHeaders);
    }
  }, [disabled, t]);

  return headers;
};
